import React from 'react'
import { PapersTableList } from 'components/papers'

type PapersProps = {
  request?: any
}

export const Papers: React.FC<PapersProps> = ({ request }) => {
  return (
    <>
      <PapersTableList request={request} />
    </>
  )
}
